// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__23QM9","empty":"ModalGraph_empty__2fhCq"};